import { AfterContentChecked, ChangeDetectorRef, Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { RestService } from './../../services/rest.service';
import {LoadingController, NavController, Platform, ToastController} from '@ionic/angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SwiperComponent } from 'swiper/angular';
import SwiperCore, { Navigation, Pagination } from 'swiper';
import { UtilService } from '../../services/util.service';
import {Location} from "@angular/common";
// Pixel library importing
import { PixelService } from 'ngx-pixel';
import {ShareMenu} from "share-menu";


SwiperCore.use([Navigation, Pagination]);

@Component({
  selector: 'app-post-services-details',
  templateUrl: './post-services-details.page.html',
  styleUrls: ['./post-services-details.page.scss'],
})
export class PostServicesDetailsPage implements OnInit {

  banners: any[];
  form: FormGroup;
  @ViewChild('swiper') swiper: SwiperComponent;
  @ViewChild('swiper34M', { static: true }) swiper34M: ElementRef;
  @ViewChild('popover') popover;
  id: any;
  subtype: any;

  loadMostWanted: boolean;
  helpFocus: boolean;
  showOverSearch: boolean;
  searchTop: string;
  isMobile: boolean;
  profile: any;
  load: boolean;
  profiles: any;
  dataSearch: any;
  user: any;
  modalShowRegister: boolean;
  modalShowRegisterTelco: boolean;
  arrayInstrument: any[] = [];
  isOpen: boolean;

  constructor(
    public rest: RestService,
    public navCtrl: NavController,
    public domSanitizer: DomSanitizer,
    public route: ActivatedRoute,
    public platform: Platform,
    public formBuilder: FormBuilder,
    public util: UtilService,
    public loadingCtrl: LoadingController,
    private pixel: PixelService,
    private locationRouter: Location,
    public toastCtrl: ToastController,
  ) {

    if (this.platform.is('android') || this.platform.is('ios')) {
      this.isMobile = true;
    }

    this.form = this.formBuilder.group({
      text: ['', Validators.required],
    });
    this.get_banners();
  }

  ngOnInit() {
    this.load = false;
    this.id = this.route.snapshot.paramMap.get('id');
    this.id = this.id.split('-')[0];
    this.subtype = this.route.snapshot.paramMap.get('subtype');

    setTimeout(() => {
      this.rest.getStorage('user').then((val) => {
        this.user = val;
        console.log(val);
        if (!val) {
          this.getDataGuest();
        } else {
          this.getData();
        }
      });

    }, 500);
    // https://v2.louderband.com/api/accounts/user-information/7275?
  }

  ionViewDidEnter() {
    this.load = false;
    this.id = this.route.snapshot.paramMap.get('id');
    this.id = this.id.split('-')[0];
    this.subtype = this.route.snapshot.paramMap.get('subtype');

    setTimeout(() => {
      this.rest.getStorage('user').then((val) => {
        this.user = val;
        console.log(val);
        if (!val) {
          this.getDataGuest();
        } else {
          this.getData();
        }
      });

    }, 500);
  }

  onResize1(event) {
    try {
      if (event.target.innerWidth < 800) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    } catch (error) {
      console.log(error);
    }
  }

  slideNext() {
    this.swiper?.swiperRef.slideNext();
  }
  slidePrev() {
    this.swiper?.swiperRef.slidePrev();
  }
  onChange() { }


  outData(ev) {
    if (ev && ev.editProfile) {
      this.navCtrl.navigateForward('mi-perfil');
    }

    if (ev && ev.focus) {
      this.showOverSearch = true;
      if (ev.search === '') {
        this.searchTop = '';
      }
      setTimeout(() => {
        this.helpFocus = true;
      }, 1800);
    }

    if (ev && ev.login) {
      // this.openLogin();
      this.navCtrl.navigateRoot('/login');
    }

    if (ev && ev.home) {
      let url = '/home';
      this.locationRouter.go(url);
    }

    if (ev && ev.referred) {
      let url = '/referred';
      this.navCtrl.navigateRoot(url);
    }

    if (ev && ev.old) {
      // this.navCtrl.navigateRoot('/registro')
      this.gotoOldApp(ev.view);
    }


    if (ev && ev.search) {
      console.log(ev.search);
      this.searchTop = ev.search;

    }

    if (ev && typeof ev.isMobile === 'boolean') {
      // console.log(ev);
      this.isMobile = ev.isMobile;
    }

  }

  outData2(ev) {
    //console.log(ev);
    if (ev.banners) {
      // this.banners = ev.banners
    }
    if (ev && ev.blur) {
      this.showOverSearch = false;
      this.searchTop = null;
      this.helpFocus = false;
    }
  }

  gotoOldApp(view?) {
    console.log(view);

    if (view) {
      this.navCtrl.navigateForward(view);
    } else {
      window.open('https://louderband.com/', '_self');
    }


  }

  getProfiles(profiles) {
    return profiles.map(e => e.description).join(' - ');
  }

  gotoProfile(val) {
    this.navCtrl.navigateBack('perfiles/'+ val);
  }

  getAlbumExtraInformation(album) {
    let information = '';
    let artists = JSON.parse(album.artists);
    if (artists && artists.length) {
      information += artists.join(',');
    }

    information += ' (' + (new Date(album.release_date)).getFullYear() + ')';
    return information;
  }

  get_banners() {
    this.banners = [];
    this.get_Banners('service_lesson_view');
  }

  get_Banners(section) {

    const default_banner = "assets/imagen/img_bg_top.png";

    this.banners.push({ 'banner_section': section, 'banner_image': default_banner });

    let apiHelp = 'banners';

    if (!this.util.token) {
      apiHelp += '/guest'
    }

    if (section) {
      this.rest._get(apiHelp + '/' + section).subscribe(async (response) => {

        var banner: any = response.body;

        console.log('Banner for section ' + section, banner.data.banner);

        if (banner.data.banner) {
          banner.data.banner.forEach((b) => {
            this.banners.push(b);
          });

          console.log('Banners: ', this.banners);
        }
      }, (error) => {
        console.log('Error getting banner: ', error);
      });
    }
  }

  findBanner(section, mobile = false) {
    let banner = this.banners.find(e => (e.banner_section == section && e.is_mobile == mobile));

    if (banner) {
      return banner;
    } else {
      return this.banners[0];
    }

  }

  clickBanner(banner) {
    console.log(banner);
    if (banner && (banner.banner_url && banner.banner_target)) {
      window.open(banner.banner_url, banner.banner_target);
    }

    // window.location = banner.banner_url;
  }

  onSwiper(ev) {
    //TODO
  }

  onSlideChange() {
    // TODO
  }

  async getData(){
  const auxLoading = await this.loadingCtrl.create({});
  await auxLoading.present();
  this.rest._get((this.subtype === 'LessonSearch' ? 'lessons/searches/' : 'services/searches/')+this.id).subscribe(async (resespone: any) => {
    const res: any = resespone.body;
    this.dataSearch = res;
    this.arrayInstrument = this.dataSearch.instruments.map(instrument => instrument.name);
    this.get_album();
    this.load = true;
    await auxLoading.dismiss();
  }, async (error) => {
    await auxLoading.dismiss();
    console.error('error: ', error);
    // this.loadingModal(error.message);
  });
}
  async getDataGuest(){
    const auxLoading = await this.loadingCtrl.create({});
    await auxLoading.present();
    this.rest._get((this.subtype === 'LessonSearch' ? 'lessons/guest/searches/' : 'services/guest/searches/')+this.id).subscribe(async (resespone: any) => {
      const res: any = resespone.body;
      this.dataSearch = res;
      this.arrayInstrument = this.dataSearch.instruments.map(instrument => instrument.name);
      this.get_album();
      this.load = true;
      await auxLoading.dismiss();
    }, async (error) => {
      await auxLoading.dismiss();
      console.error('error: ', error);
      // this.loadingModal(error.message);
    });
  }

  get_album() {
    const apiHelp = 'discs/user/' + this.dataSearch.owner.id;
    this.rest._get(apiHelp).subscribe(async (response) => {
      const album: any = response.body;
      this.dataSearch.owner.albums = (album.data.discs && album.data.discs.length > 5) ? album.data.discs.slice(0, 4) : [];
    }, (error) => {
      console.error('error: ', error);
    });
  }

  sendMessage() {
    const email = new RegExp("^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9_\\-\\.]+)\\.([a-zA-Z]{2,5})$");
    if (this.util.token && this.util.user.msisdn === null
      || (this.util.token && this.util.user.msisdn !== null && (email.test(this.util.user.email) === true))) {
      const textForm = this.form.value;
      const body = 'Mensaje enviado a partir de la busqueda: ' + '\n' + this.dataSearch.title + '\n' + window.location.href + '\n' + textForm.text;

      this.util.setChatTargetUser(this.dataSearch.owner);
      let chat_link = location.origin + '/mensajes/usuario/' + this.dataSearch.owner.id + '/' + encodeURIComponent(body);

      window.open(chat_link, '_self');
    }else if(this.util.token && this.util.user.msisdn !== null && (email.test(this.util.user.email) === false)){
      this.showModalRegisterTelco();
    }
    else {
      this.showModalRegister();
    }
  }
  gotoLogin() {
    this.navCtrl.navigateForward('/login');
    this.modalShowRegister = false;
  }

  gotoRegister() {
    this.navCtrl.navigateForward('/registro');
  }

  showModalRegister() {
    this.modalShowRegister = !this.modalShowRegister;
  }

  showModalRegisterTelco() {
    this.modalShowRegisterTelco = !this.modalShowRegisterTelco;
  }

  presentPopover(e: Event) {
    this.popover.event = e;
    this.isOpen = true;
  }

  shareProfileDesktop(){
    const url = 'https://louderband.com/busquedas-publicadas/'+ this.subtype + '/' + this.id;
    if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(async () => {
        const toast = await this.toastCtrl.create({
          message: 'La URL se ha copiado al portapapeles.',
          duration: 2000,
          position: 'top'
        });
        await toast.present();
      }).catch((async ()=> {
        const toast = await this.toastCtrl.create({
          message: 'No se pudo copiar la URL al portapapeles.',
          duration: 2000,
          position: 'top'
        });
        await toast.present();
      }));
    };
  }

  shareDevice(index: number) {
    const element = document.querySelector('share-menu') as ShareMenu;
    element.targets[index].share(element);
  }

  goBack() {
    this.navCtrl.back();
  }
}
